console.log('Quiz script loaded');
document.addEventListener('DOMContentLoaded', function () {
    let currentDogIndex = 0;
    let quizAnswers = [];
    const totalQuestionsStep1 = 4;
    const totalQuestionsStep2 = 7;
    const steps = document.querySelectorAll('.quiz-step');
    const progressSteps = document.querySelectorAll('.progress-step');
    let currentStep = 0;
    let currentQuestion = 0;
    loadFromLocalStorage();
    updateQuizAnswers();

    // fx new dog
    function addNewDog() {
        const newDog = {
            name: '',
            gender: '',
            age: {
                year: '',
                month: '',
            },
            breed: '',
            dogWeightKg: {
                value: '',
                unit: '',
            },
            neutered: '',
            bodyCondition: '',
            activityLevel: '',
            transition: '',
            goals: '',
            email: '',
            phone: '',
            phoneDialCode: '',
            phoneCountry: '',
            mealPreference: '',
            proteinPreference: [],
            mealPlanType: '',
            treatsPreference: [],
            currentQuestion: 0,
            currentStep: 0,
        };
        quizAnswers.push(newDog);
        saveToLocalStorage();
    }

    // save in LocalStorage
    function saveToLocalStorage() {
        if (Array.isArray(quizAnswers)) {
            localStorage.setItem('quizAnswers', JSON.stringify(quizAnswers));
        }
    }
    currentStep = quizAnswers[currentDogIndex].currentStep;
    currentQuestion = quizAnswers[currentDogIndex].currentQuestion;
    if (currentStep == undefined || currentQuestion == undefined) {
        localStorage.removeItem('quizAnswers');
        setTimeout(() => {
            window.location.reload();
        }, 3000); 
    }
    const nameElements = document.querySelectorAll('.dog-name');
    nameElements.forEach((nameElement) => {
        if (nameElement) {
            nameElement.innerHTML = quizAnswers[currentDogIndex]?.name || 'your dog';
        }
    });

    const input = document.querySelector("#phone");
    if (!input) {
        return;
    }
    window.intlTelInput(input, {
        initialCountry: "ca",
        preferredCountries: ["ca", "us", "gb"],
        separateDialCode: true,
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js"
    });

    // load LocalStorage
    function loadFromLocalStorage() {
        const savedData = localStorage.getItem('quizAnswers');
        if (savedData) {
            quizAnswers = JSON.parse(savedData) || [];
            if (!Array.isArray(quizAnswers) || quizAnswers.length === 0) {
                quizAnswers = [];
                addNewDog();
            }
        } else {
            quizAnswers = [];
            addNewDog();
        }
        currentDogIndex = quizAnswers.length - 1;
    }

    // update quiz info
    function updateQuizAnswers() {
        const currentDog = quizAnswers[currentDogIndex] || {};
        // save name
        const nameInput = document.getElementById('name');
        if (nameInput && nameInput.value.trim() !== '') {
            currentDog.name = nameInput.value;
        }

        // save gender
        const maleButton = document.getElementById('male-btn');
        const femaleButton = document.getElementById('female-btn');

        if (maleButton && femaleButton) {
            maleButton.addEventListener('click', function () {
                quizAnswers[currentDogIndex].gender = 'boy';
                saveToLocalStorage();
            });

            femaleButton.addEventListener('click', function () {
                quizAnswers[currentDogIndex].gender = 'girl';
                saveToLocalStorage();
            });
        }

        // save age
        const ageInput1 = document.getElementById('age-years');
        const ageInput2 = document.getElementById('age-months');
        if (ageInput1 && ageInput2) {
            currentDog.age = {
                year: ageInput1.value.trim(),
                month: ageInput2.value.trim(),
            };
        }

        //save breed
        const breedSelect = document.getElementById('breed');
        const otherBreedInput = document.getElementById('other-breed');
        const breedNextButton = document.querySelector('#step-1-q4 .next-step');

        if (breedSelect && otherBreedInput) {
            breedSelect.addEventListener('change', function () {
                if (breedSelect.value === 'Other') {
                    otherBreedInput.style.display = 'block';
                    otherBreedInput.addEventListener('input', function () {
                        quizAnswers[currentDogIndex].breed = otherBreedInput.value.trim();
                        saveToLocalStorage();
                    });
                } else {
                    quizAnswers[currentDogIndex].breed = breedSelect.value;
                    otherBreedInput.value = '';
                    otherBreedInput.style.display = 'none';
                    saveToLocalStorage();
                }

                if (breedSelect.value === '') {
                    breedNextButton.disabled = false;
                } else {
                    breedNextButton.disabled = false;
                }
            });
        }

        // save weight
        const weightInput = document.getElementById('weight');
        const lbsRadio = document.getElementById('lbs');
        const kgRadio = document.getElementById('kg');
        const lbsLabel = document.getElementById('label-lbs');
        const kgLabel = document.getElementById('label-kg');
        const nextButtonWeight = document.querySelector('#step-2-q1 .next-step');
        if (weightInput && lbsRadio && kgRadio && lbsLabel && kgLabel) {
            function updateLabelStyles() {
                if (lbsRadio.checked) {
                    lbsLabel.classList.add('active');
                    lbsLabel.classList.remove('inactive');
                    kgLabel.classList.remove('active');
                    kgLabel.classList.add('inactive');
                } else {
                    kgLabel.classList.add('active');
                    kgLabel.classList.remove('inactive');
                    lbsLabel.classList.remove('active');
                    lbsLabel.classList.add('inactive');
                }
            }
            updateLabelStyles();
            lbsRadio.addEventListener('change', updateLabelStyles);
            kgRadio.addEventListener('change', updateLabelStyles);
            function toggleNextButtonWeight() {
                if (weightInput.value.trim() !== '') {
                    nextButtonWeight.disabled = false;
                } else {
                    nextButtonWeight.disabled = true;
                }
            }
            weightInput.addEventListener('input', toggleNextButtonWeight);
            nextButtonWeight.addEventListener('click', function () {
                let dogWeightKg = parseFloat(weightInput.value.trim());
                let unit = lbsRadio.checked ? 'lbs' : 'kg';
                if (unit === 'lbs') {
                    dogWeightKg = (dogWeightKg / 2.20462).toFixed(2);
                }
                quizAnswers[currentDogIndex].dogWeightKg = dogWeightKg;
                saveToLocalStorage();
            });
        }
        // save neutered
        const neuteredYes = document.getElementById('neutered-btn-yes');
        const neuteredNo = document.getElementById('neutered-btn-no');

        if (neuteredYes && neuteredNo) {
            neuteredYes.addEventListener('click', function () {
                quizAnswers[currentDogIndex].neutered = 'yes';
                saveToLocalStorage();
            });

            neuteredNo.addEventListener('click', function () {
                quizAnswers[currentDogIndex].neutered = 'no';
                saveToLocalStorage();
            });
        }

        // save body condition
        const bodyBelow = document.getElementById('below-btn');
        const bodySuitable = document.getElementById('suitable-btn');
        const bodyaAbove = document.getElementById('above-btn');

        if (bodyBelow && bodySuitable && bodyaAbove) {
            bodyBelow.addEventListener('click', function () {
                quizAnswers[currentDogIndex].bodyCondition = 'below';
                saveToLocalStorage();
            });

            bodySuitable.addEventListener('click', function () {
                quizAnswers[currentDogIndex].bodyCondition = 'adequate';
                saveToLocalStorage();
            });
            bodyaAbove.addEventListener('click', function () {
                quizAnswers[currentDogIndex].bodyCondition = 'above';
                saveToLocalStorage();
            });
        }

        // save activity
        const activityLow = document.getElementById('activity-low');
        const activityModerate = document.getElementById('activity-moderate');
        const activityaHigh = document.getElementById('activity-high');

        if (activityLow && activityModerate && activityaHigh) {
            activityLow.addEventListener('click', function () {
                quizAnswers[currentDogIndex].activityLevel = 'low';
                saveToLocalStorage();
            });

            activityModerate.addEventListener('click', function () {
                quizAnswers[currentDogIndex].activityLevel = 'moderate';
                saveToLocalStorage();
            });
            activityaHigh.addEventListener('click', function () {
                quizAnswers[currentDogIndex].activityLevel = 'high';
                saveToLocalStorage();
            });
        }

        // Save transition
        const transitionYes = document.getElementById('transition-btn-yes');
        const transitionNo = document.getElementById('transition-btn-no');

        if (transitionYes && transitionNo) {
            transitionYes.addEventListener('click', function () {
                quizAnswers[currentDogIndex].transition = 'yes';
                saveToLocalStorage();
            });

            transitionNo.addEventListener('click', function () {
                quizAnswers[currentDogIndex].transition = 'no';
                saveToLocalStorage();
            });
        }

        // Save goals
        const improvedDigestionCheckbox = document.getElementById('improved_digestion');
        const healthierSkinCheckbox = document.getElementById('healthier_skin');
        const weightManagementCheckbox = document.getElementById('weight_management');
        const increasedEnergyCheckbox = document.getElementById('increased_energy');
        const strongerImmuneSystemCheckbox = document.getElementById('stronger_immune_system');
        const qualityOfLifeCheckbox = document.getElementById('quality_of_life');

        function saveGoals() {
            const selectedGoals = [];

            if (improvedDigestionCheckbox.checked) {
                selectedGoals.push('improved_digestion');
            }
            if (healthierSkinCheckbox.checked) {
                selectedGoals.push('healthier_skin');
            }
            if (weightManagementCheckbox.checked) {
                selectedGoals.push('weight_management');
            }
            if (increasedEnergyCheckbox.checked) {
                selectedGoals.push('increased_energy');
            }
            if (strongerImmuneSystemCheckbox.checked) {
                selectedGoals.push('stronger_immune_system');
            }
            if (qualityOfLifeCheckbox.checked) {
                selectedGoals.push('quality_of_life');
            }

            quizAnswers[currentDogIndex].goals = selectedGoals;
            saveToLocalStorage();
        }

        if (
            improvedDigestionCheckbox &&
            healthierSkinCheckbox &&
            weightManagementCheckbox &&
            increasedEnergyCheckbox &&
            strongerImmuneSystemCheckbox &&
            qualityOfLifeCheckbox
        ) {
            improvedDigestionCheckbox.addEventListener('change', saveGoals);
            healthierSkinCheckbox.addEventListener('change', saveGoals);
            weightManagementCheckbox.addEventListener('change', saveGoals);
            increasedEnergyCheckbox.addEventListener('change', saveGoals);
            strongerImmuneSystemCheckbox.addEventListener('change', saveGoals);
            qualityOfLifeCheckbox.addEventListener('change', saveGoals);
        }

        //save email
        const emailInput = document.getElementById('email');
        const phoneInput = document.getElementById('phone');
        const termsCheckbox = document.getElementById('terms-checkbox');
        const buildPlanButton = document.getElementById('build-plan-button');
        const emailErrorMessage = document.getElementById('email-error-message');
        const phoneErrorMessage = document.getElementById('phone-error-message');
        const termsLink = document.getElementById('terms-link');
        const termsModal = document.getElementById('terms-modal');
        const closeModalButton = document.querySelector('.close-modal');


        function validateEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }
        function validatePhone(phone) {
            const phoneRegex = /^\d{10,11}$/;
            return phoneRegex.test(phone);
        }
        if (phoneInput) {
            phoneInput.addEventListener('input', function () {
                this.value = this.value.replace(/\D/g, ''); 
            });
        }

        function toggleBuildPlanButton() {
            const isEmailValid = validateEmail(emailInput.value);
            const isPhoneValid = validatePhone(phoneInput.value);
            const isTermsChecked = termsCheckbox.checked;

            if (isEmailValid) {
                emailInput.classList.add('valid');
                emailInput.classList.remove('invalid');
                emailInput.style.borderColor = 'green';
                emailErrorMessage.style.display = 'none';
            } else {
                emailInput.classList.add('invalid');
                emailInput.classList.remove('valid');
                emailInput.style.borderColor = 'red';
                emailErrorMessage.textContent = 'Please enter a valid email.';
                emailErrorMessage.style.display = 'block';
            }

            if (isPhoneValid) {
                phoneInput.classList.add('valid');
                phoneInput.classList.remove('invalid');
                phoneInput.style.borderColor = 'green';
                phoneErrorMessage.style.display = 'none';
            } else {
                phoneInput.classList.add('invalid');
                phoneInput.classList.remove('valid');
                phoneInput.style.borderColor = 'red';
                phoneErrorMessage.textContent = 'Please enter a phone number.';
                phoneErrorMessage.style.display = 'block';
            }

            buildPlanButton.disabled = !(isEmailValid && isTermsChecked && isPhoneValid);
        }
        if (emailInput && phoneInput) {
            emailInput.addEventListener('input', toggleBuildPlanButton);
            phoneInput.addEventListener('input', toggleBuildPlanButton);
        }
        if (termsCheckbox) {
            termsCheckbox.addEventListener('change', toggleBuildPlanButton);
        }
        if (termsLink) {
            termsLink.addEventListener('click', function (event) {
                event.preventDefault();
                termsModal.style.display = 'block';
            });
        }
        if (closeModalButton) {
            closeModalButton.addEventListener('click', function () {
                termsModal.style.display = 'none';
            });
        }

        window.addEventListener('click', function (event) {
            if (event.target === termsModal) {
                termsModal.style.display = 'none';
            }
        });
        if (buildPlanButton) {
            buildPlanButton.addEventListener('click', function () {
                const email = emailInput.value;
                const phone = phoneInput.value;
                const dialCode = document.querySelector('.iti__selected-dial-code').textContent;
                const nameCountry = document.querySelector('.iti__a11y-text').textContent.split('+')[0];
                const phoneCountry = nameCountry.trimEnd();

                if (validateEmail(email)) {
                    quizAnswers[currentDogIndex].email = email;
                    saveToLocalStorage();
                }
                if (validatePhone(phone)) {
                    quizAnswers[currentDogIndex].phone = `${phone}`;
                    saveToLocalStorage();
                }
                if (dialCode) {
                    quizAnswers[currentDogIndex].phoneDialCode = dialCode;
                    saveToLocalStorage();
                }
                if (nameCountry) {
                    quizAnswers[currentDogIndex].phoneCountry = phoneCountry;
                    saveToLocalStorage();
                }
            });
        
            //save meal preference (only gently steamed meals are offered)
            buildPlanButton.addEventListener('click', function () {
                quizAnswers[currentDogIndex].mealPreference = 'cooked';
                saveToLocalStorage();
            });
        }
        const checkboxes = document.querySelectorAll('.protein-checkbox');
        const continueButton = document.getElementById('step-3q1');
        const optionMealsSpan = document.querySelector('.option-meals');
        const toggleDiv = document.querySelector('.box-raw-gently');

        if (!quizAnswers[currentDogIndex]) {
            quizAnswers[currentDogIndex] = { proteinPreference: [] };
        }

        if (!quizAnswers[currentDogIndex].proteinPreference) {
            quizAnswers[currentDogIndex].proteinPreference = [];
        }

        const currentProteinPreference = quizAnswers[currentDogIndex].proteinPreference;

        function getCurrentPreparation() {
            return 'Gently Steamed';
        }

        let updateTimeout;
        function updateOptionMealsSpan(withDelay = false) {
            const updateAction = () => {
                const preparation = getCurrentPreparation();
                const formattedProteins = currentProteinPreference.map(
                    (protein) => `${preparation} ${protein}`
                );
                optionMealsSpan.textContent = formattedProteins.join(', ');
            };

            if (withDelay) {
                clearTimeout(updateTimeout);
                updateTimeout = setTimeout(updateAction, 300);
            } else {
                updateAction();
            }
        }

        function updateContinueButtonState() {
            continueButton.disabled = currentProteinPreference.length === 0;
        }

        function syncCheckboxes(proteinValue, isChecked) {
            checkboxes.forEach((checkbox) => {
                if (checkbox.dataset.protein === proteinValue) {
                    checkbox.checked = isChecked;
                }
            });
        }

        function handleCheckboxChange(checkbox) {
            const proteinValue = checkbox.dataset.protein;

            if (checkbox.checked) {
                if (!currentProteinPreference.includes(proteinValue)) {
                    currentProteinPreference.push(proteinValue);
                }
            } else {
                const index = currentProteinPreference.indexOf(proteinValue);
                if (index > -1) {
                    currentProteinPreference.splice(index, 1);
                }
            }

            quizAnswers[currentDogIndex].proteinPreference = [...currentProteinPreference];
            saveToLocalStorage();
            updateOptionMealsSpan();
            updateContinueButtonState();
        }

        toggleDiv.addEventListener('click', () => {
            updateOptionMealsSpan(true);
        });

        checkboxes.forEach((checkbox) => {
            const proteinValue = checkbox.dataset.protein;

            if (currentProteinPreference.includes(proteinValue)) {
                checkbox.checked = true;
            }

            checkbox.addEventListener('change', () => {
                handleCheckboxChange(checkbox);
                syncCheckboxes(proteinValue, checkbox.checked);
            });
        });

        updateOptionMealsSpan();
        updateContinueButtonState();

        // save type meal
        const nextStepButton = document.getElementById('step-3q2');
        const step3q1ButtonMeal = document.getElementById('step-3q1');
        const saveMealPlan = document.getElementById('build-plan-button');
        const topperRadio = document.getElementById('topper');
        const fullRadio = document.getElementById('full');
        const topperLabel = document.getElementById('label-topper');
        const fullLabel = document.getElementById('label-full');
        const topperBox = document.querySelectorAll('.topper-container')[0];
        const fullBox = document.querySelectorAll('.topper-container')[1];
        const parentBox = document.querySelector('.info-topper-full-box');
        const progressItem = document.querySelector('.progress-bar-container');

        function toggleNextStepButton() {
            nextStepButton.disabled = !quizAnswers[currentDogIndex]?.mealPlanType;
        }

        function updateSelection(type) {
            parentBox.classList.remove('topper-selected', 'full-selected');
            topperLabel.classList.remove('selected');
            fullLabel.classList.remove('selected');

            if (type === 'topper') {
                parentBox.classList.add('topper-selected');
                topperLabel.classList.add('selected');
                quizAnswers[currentDogIndex].mealPlanType = 'topper';
            } else if (type === 'full') {
                parentBox.classList.add('full-selected');
                fullLabel.classList.add('selected');
                quizAnswers[currentDogIndex].mealPlanType = 'full';
                fullRadio.checked = true;
            }

            saveToLocalStorage();
            toggleNextStepButton();
        }
        if (saveMealPlan) {
            saveMealPlan.addEventListener('click', () => {
                updateSelection('full');
            });
        }

        if (progressItem) {
            step3q1ButtonMeal.addEventListener('click', () => {
                progressItem.scrollIntoView({ behavior: 'smooth' });
            });
        }

        topperRadio.addEventListener('change', () => {
            if (topperRadio.checked) {
                updateSelection('topper');
            }
        });
        fullRadio.addEventListener('change', () => {
            if (fullRadio.checked) {
                updateSelection('full');
            }
        });
        topperBox.addEventListener('click', () => {
            topperRadio.checked = true;
            updateSelection('topper');
        });
        fullBox.addEventListener('click', () => {
            fullRadio.checked = true;
            updateSelection('full');
        });

        const savedPreference = quizAnswers[currentDogIndex]?.mealPlanType;
        if (savedPreference === 'topper') {
            topperRadio.checked = true;
            updateSelection('topper');
        } else if (savedPreference === 'full') {
            fullRadio.checked = true;
            updateSelection('full');
        } else {
            toggleNextStepButton();
        }

        quizAnswers[currentDogIndex] = currentDog;
        saveToLocalStorage();
    }

    // update icons steps
    function updateProgress(step) {
        progressSteps.forEach((stepElement, index) => {
            const svgWrappers = stepElement.querySelectorAll('.svg-wrapper');
            const activeSvg = stepElement.getAttribute('data-active-svg');
            const completedSvg = stepElement.getAttribute('data-completed-svg');
            const defaultSvg = stepElement.querySelector('span').innerHTML;
            const defaultSvgDef = stepElement.getAttribute('default-svg');

            svgWrappers.forEach((svgWrapper) => {
                if (index < step) {
                    svgWrapper.innerHTML = `<img src="${completedSvg}" alt="Completed step">`;
                } else if (index === step) {
                    svgWrapper.innerHTML = `<img src="${activeSvg}" alt="Active step">`;
                } else {
                    svgWrapper.innerHTML = `<img src="${defaultSvgDef}" alt="Default">`;
                }
            });
        });
        if (step === 0) {
            console.localStorage;
            const step2Icon = progressSteps[1].querySelector('.svg-wrapper');
            const step2DefaultSvg = progressSteps[1].querySelector('span').innerHTML;
            step2Icon.innerHTML = step2DefaultSvg;
        }
    }

    // show questions
    function showStep(step) {
        console.log('showStep called with step:', step);
        const currentDog = quizAnswers[currentDogIndex] || {};
        steps.forEach((stepElement, index) => {
            stepElement.style.display = index === step ? 'flex' : 'none';
        });
        updateProgress(step);
        showQuestion(step, currentQuestion);
        updateProgressBar();
    }

    function showQuestion(step, questionIndex) {
        const questions = steps[step].querySelectorAll('.quiz-question');
        questions.forEach((question, index) => {
            question.style.display = index === questionIndex ? 'flex' : 'none';
        });
        quizAnswers[currentDogIndex].currentStep = step;
        quizAnswers[currentDogIndex].currentQuestion = questionIndex;
        saveToLocalStorage();
    }

    showStep(currentStep);

    //activate next step btn
    const nameInput = document.getElementById('name');
    const yearInput = document.getElementById('age-years');
    const monthInput = document.getElementById('age-months');
    const nextButton = document.querySelector('.next-step');
    const nextButton2 = document.querySelector('#step-1-q3 .next-step');

    // fx check name
    function checkNameInput() {
        if (nameInput.value.trim() === '') {
            nextButton.disabled = true;
            nameInput.classList.add('shake');
            nextButton.style.backgroundColor = '#A2A2A2';
        } else {
            nextButton.disabled = false;
            nameInput.classList.remove('shake');
            nextButton.style.backgroundColor = '';
        }
    }
    function checkYearMonthInput() {
        if (yearInput.value.trim() === '' && monthInput.value.trim() === '') {
            yearInput.classList.add('shake');
            monthInput.classList.add('shake');
            nextButton2.disabled = true;
            nextButton2.style.backgroundColor = '#A2A2A2';
        } else {
            yearInput.classList.remove('shake');
            monthInput.classList.remove('shake');
            nextButton2.disabled = false;
            nextButton2.style.backgroundColor = '';
        }
    }

    nameInput.addEventListener('input', checkNameInput);
    yearInput.addEventListener('input', checkYearMonthInput);
    monthInput.addEventListener('input', checkYearMonthInput);

    checkNameInput();
    checkYearMonthInput();

    document.querySelectorAll('.next-step').forEach((button) => {
        button.addEventListener('click', function () {

            // "Next" question logic
            updateQuizAnswers();
            const nameElements = document.querySelectorAll('.dog-name');
            nameElements.forEach((nameElement) => {
                if (nameElement) {
                    nameElement.innerHTML = quizAnswers[currentDogIndex]?.name || 'your dog';
                }
            });

            const questions = steps[currentStep].querySelectorAll('.quiz-question');

            if (currentQuestion < questions.length - 1) {
                currentQuestion++;
                updateProgressBar();
                showQuestion(currentStep, currentQuestion);
            } else if (currentStep < steps.length - 1) {
                currentStep++;
                updateProgressBar();
                currentQuestion = 0;
                showStep(currentStep);
                showQuestion(currentStep, currentQuestion);
            }
        });
    });

    // "Previous" question logic
    document.querySelectorAll('.prev-question').forEach((button) => {
        button.addEventListener('click', function () {
            console.log('click Previous question clicked');
            if (currentQuestion > 0) {
                currentQuestion--;
                updateProgressBar();
                showQuestion(currentStep, currentQuestion);
            } else if (currentStep > 0) {
                currentStep--;
                updateProgressBar();
                currentQuestion = steps[currentStep].querySelectorAll('.quiz-question').length - 1;
                showStep(currentStep);
                showQuestion(currentStep, currentQuestion);
            }
        });
    });

    // update progress bar
    function updateProgressBar() {
        const progressBarStep1 = document.querySelector('.progress-line-step1 .progress-fill');
        const progressBarStep2 = document.querySelector('.progress-line-step2 .progress-fill');

        if (currentStep === 0 && progressBarStep1) {
            let progressPercentageStep1 = ((currentQuestion + 1) / totalQuestionsStep1) * 100;
            progressBarStep1.style.width = `${progressPercentageStep1}%`;

            if (progressBarStep2) {
                progressBarStep2.style.width = '0%';
            }
        } else if (currentStep === 1 && progressBarStep2) {
            let progressPercentageStep2 = ((currentQuestion + 1) / totalQuestionsStep2) * 100;
            progressBarStep1.style.width = `100%`;
            progressBarStep2.style.width = `${progressPercentageStep2}%`;
        } else {
            console.error('Not found');
        }
    }

    updateProgressBar();

    // btn new dog
    // {% comment %}     
    //  const addAnotherDogButton = document.getElementById('add-another-dog');
    //   if (addAnotherDogButton) {
    //     addAnotherDogButton.addEventListener('click', function () {
    //       addNewDog();
    //     });
    //   } else {
    //     console.error("Element with id 'add-another-dog' not found");
    //   } 
    // {% endcomment %}
});



// adjust input months
document.addEventListener('DOMContentLoaded', function () {
    const ageMonthsInput = document.getElementById('age-months');
    if (!ageMonthsInput) {
        return;
    }
    ageMonthsInput.addEventListener('input', function () {
        if (parseInt(this.value) > 11) {
            this.value = 11;
        }
    });
});



// adjust input value weight

document.addEventListener('DOMContentLoaded', function () {
    const weight = document.getElementById('weight');
    if (!weight) {
        return;
    }
    [weight].forEach((element) => {
        element.addEventListener('input', function () {
            if (parseInt(this.value) < 1) {
                this.value = 1;
            }
        });
    });
});



// adjust modal behavior
document.addEventListener('DOMContentLoaded', () => {
    function closeModal(modal) {
        if (modal) {
            modal.classList.remove('active');
            modal.style.display = 'none';
            document.body.style.overflow = '';
        }
    }

    document.querySelectorAll('.recipe-link').forEach((button) => {
        button.addEventListener('click', (event) => {
            console.log('Recipe link clicked');
            event.preventDefault();

            // Encontra o card correspondente ao botão clicado
            const recipeCard = button.closest('.recipe-card-raw, .recipe-card-gently');
            if (!recipeCard) {
                console.error('Não foi possível localizar o card correspondente.');
                return;
            }

            // Determina o tipo de receita (raw ou gently)
            const recipeType = recipeCard.classList.contains('recipe-card-raw') ? 'raw' : 'gently';

            // Obtém o tipo de proteína a partir do atributo data-protein
            const proteinCheckbox = recipeCard.querySelector('.protein-checkbox');
            const proteinType = proteinCheckbox?.getAttribute('data-protein');

            if (!proteinType) {
                console.error('Tipo de proteína não encontrado.');
                return;
            }

            // Gera o seletor do modal com base no tipo de receita e proteína
            const modalSelector = `.custom-modal-${recipeType}-${proteinType.toLowerCase()}`;
            const modal = document.querySelector(modalSelector);
            console.log(`Modal selector:.......`, modalSelector, modal);

            if (modal) {
                modal.classList.add('active');
                modal.style.display = 'block';
                document.body.style.overflow = 'hidden';
            } else {
                console.error(`Modal não encontrado para o seletor: ${modalSelector}`);
            }
        });
    });

    // Opcional: Fechar o modal ao clicar no botão de fechar
    document.querySelectorAll('.modal-close').forEach((closeButton) => {
        closeButton.addEventListener('click', () => {
            const modal = closeButton.closest('.custom-modal');
            if (modal) {
                modal.classList.remove('active');
                modal.style.display = 'none';
                document.body.style.overflow = '';
            }
        });
    });

    document.querySelectorAll('.recipe-modal__close-btn').forEach((button) => {
        button.addEventListener('click', () => {
            const modal = button.closest('.custom-modal, .modal-cart');
            closeModal(modal);
        });
    });

    document.querySelectorAll('.custom-modal').forEach((modal) => {
        modal.addEventListener('click', (event) => {
            if (event.target.classList.contains('custom-modal-overlay')) {
                closeModal(modal);
            }
        });
    });
});




// function cart btn
document.addEventListener('DOMContentLoaded', function () {
    const cartQuiz = document.querySelector('.cart-quiz');
    const step3 = document.getElementById('step-3');
    const step3q2 = document.getElementById('step-3-q2');
    const step3q3 = document.getElementById('step-3-q3');
    const secureCheckoutButton = document.querySelector('.cart-quiz-checkout');
    const addAnotherDogButton = document.getElementById('add-another-dog');
    const navigationButtons = document.querySelectorAll('.next-step, .back-step, .prev-question');
    const startOverButton = document.getElementById('start-over');


    function isDisplayedFlex(element) {
        if (element) {
            return window.getComputedStyle(element).display === 'flex';
        }
        return false;
    }
    if (!startOverButton) {
        return;
    }
    startOverButton.addEventListener('click', function () {
        try {
            localStorage.removeItem('quizAnswers');
        } catch (e) {
            console.warn('Error', e);
        }
        window.location.reload();
    });

    function updateCartQuizState() {
        const isStep3Visible = isDisplayedFlex(step3);
        const isStep3q2Visible = isDisplayedFlex(step3q2);
        const isStep3q3Visible = isDisplayedFlex(step3q3); 

        cartQuiz.style.display = isStep3Visible && (isStep3q2Visible || isStep3q3Visible) ? 'block' : 'none';

        secureCheckoutButton.disabled = false;
        addAnotherDogButton.disabled = false;

        navigationButtons.forEach((button) => {
            // {% comment %} button.disabled = false; 
        });
    }

    updateCartQuizState();

    navigationButtons.forEach((button) => {
        button.addEventListener('click', updateCartQuizState);
    });
});



//update URL
function updateURLWithStepAndQuestion() {
    const visibleQuestion = getVisibleQuestion();
    if (visibleQuestion) {
        const url = new URL(window.location.href);

        const stepParam = visibleQuestion.closest('[id^="step-"]').id.replace('step-', '').split('-')[0];
        const questionParam = visibleQuestion.getAttribute('data-name') || '';

        url.searchParams.set('step', stepParam);
        url.searchParams.set('q', questionParam);

        history.replaceState(null, '', url.toString());
    }
}

function getVisibleQuestion() {
    const steps = document.querySelectorAll('[id^="step-"]');

    for (const step of steps) {
        const stepStyles = window.getComputedStyle(step);
        if (stepStyles.display === 'flex') {
            const visibleQuestion = Array.from(step.querySelectorAll('[data-name]')).find((child) => {
                const childStyles = window.getComputedStyle(child);
                return childStyles.display === 'flex';
            });
            if (visibleQuestion) return visibleQuestion;
        }
    }
    return null;
}

function initializeQuizNavigation() {
    updateURLWithStepAndQuestion();

    const navigationButtons = document.querySelectorAll('.next-step, .back-step, .prev-question');
    navigationButtons.forEach((button) => {
        button.addEventListener('click', () => {
            setTimeout(updateURLWithStepAndQuestion, 100);
        });
    });
}

window.addEventListener('DOMContentLoaded', initializeQuizNavigation);



// main function
const metabolizableEnergyPerKg = 1150;
const variantsList = [
    {
        title: 'S1',
        weight: 250,
    },
    {
        title: 'S2',
        weight: 300,
    },
    {
        title: 'M1',
        weight: 350,
    },
    {
        title: 'M2',
        weight: 450,
    },
    {
        title: 'L1',
        weight: 550,
    },
];
const portionWeights = [250, 300, 350, 450, 550];
const mealsPerDelivery = 14;
const topperSellingPlan = {
    id: 12206604452,
    frequency: 'every month',
    description: 'Monthly Subscription',
    planDescription: 'Topper: 50% of Nutritional Needs',
    amountDescription: "1 month's worth of food",
    daysOfFood: 28,
};

const fullSellingPlan = {
    id: 12206669988,
    frequency: 'every 2 weeks',
    description: 'Biweekly Subscription',
    planDescription: 'Full: 100% of Nutritional Needs',
    amountDescription: "2 weeks' worth of food",
    daysOfFood: 14,
};
function executeCodeFirst() {
    let quizAnswers = JSON.parse(localStorage.getItem('quizAnswers')) || [];
    const currentDogIndex = 0;
    const currentDog = quizAnswers[currentDogIndex];
    const {
        name,
        gender,
        age,
        breed,
        dogWeightKg,
        neutered,
        bodyCondition,
        activityLevel,
        goals,
        email,
        phone,
        transition,
        proteinPreference,
        mealPlanType,
        treatsPreference,
    } = currentDog;
    // raw meals were discontinued, so every plan uses the gently steamed (cooked) products
    const mealPreference = 'cooked';

    const energyFactor = getEnergyFactor(neutered, activityLevel, bodyCondition);
    function getEnergyFactor(neutered, activityLevel, bodyCondition) {
        const energyFactors = {
            'yes-low-below': 95,
            'yes-low-adequate': 85,
            'yes-low-above': 75,
            'yes-high-below': 95,
            'yes-high-adequate': 95,
            'yes-high-above': 85,
            'yes-moderate-below': 95,
            'yes-moderate-adequate': 85,
            'yes-moderate-above': 75,
            'no-low-below': 100,
            'no-low-adequate': 95,
            'no-low-above': 85,
            'no-high-below': 100,
            'no-high-adequate': 95,
            'no-high-above': 85,
            'no-moderate-below': 85,
            'no-moderate-adequate': 95,
            'no-moderate-above': 85,
        };

        const validNeuteredValues = ['yes', 'no'];
        const validActivityLevels = ['low', 'moderate', 'high'];
        const validBodyConditions = ['below', 'adequate', 'above'];

        if (
            !validNeuteredValues.includes(neutered) ||
            !validActivityLevels.includes(activityLevel) ||
            !validBodyConditions.includes(bodyCondition)
        ) {
            return null;
        }

        const key = `${neutered}-${activityLevel}-${bodyCondition}`;
        const energyFactor = energyFactors[key];
        return energyFactor !== undefined ? energyFactor : null;
    }

    const maintenanceEnergyRequirement = getMaintenanceEnergyRequirement(energyFactor, dogWeightKg);
    function getMaintenanceEnergyRequirement(energyFactor, dogWeightKg) {
        let maintenanceEnergyRequirement = 0;
        dogWeightKg = parseFloat(dogWeightKg);

        const isValidEnergyFactor = typeof energyFactor === 'number' && energyFactor > 0;
        const isValidDogWeight = typeof dogWeightKg === 'number' && dogWeightKg > 0;

        if (isValidEnergyFactor && isValidDogWeight) {
            maintenanceEnergyRequirement = energyFactor * Math.pow(dogWeightKg, 0.75);
        }

        return maintenanceEnergyRequirement;
    }

    const recommendedDailyDiet = getRecommendedDailyDiet(maintenanceEnergyRequirement, metabolizableEnergyPerKg);
    function getRecommendedDailyDiet(maintenanceEnergyRequirement, metabolizableEnergyPerKg) {
        let recommendedDailyDiet = null;

        const isValidMaintenanceEnergy =
            typeof maintenanceEnergyRequirement === 'number' && maintenanceEnergyRequirement > 0;

        if (isValidMaintenanceEnergy) {
            recommendedDailyDiet = (maintenanceEnergyRequirement * 1000) / metabolizableEnergyPerKg;
        } else {
            recommendedDailyDiet = 0;
        }

        return recommendedDailyDiet;
    }

    const idealPortionUp = getRoundedUpPortion(recommendedDailyDiet, portionWeights, dogWeightKg);

    function getRoundedUpPortion(recommendedDailyDiet, portionWeights, dogWeightKg) {
        const portionOptions =
            dogWeightKg > 4.4
                ? [{ portionCount: 1 }, { portionCount: 2 }]
                : [{ portionCount: 0.5 }, { portionCount: 1 }, { portionCount: 2 }];

        if (typeof recommendedDailyDiet !== 'number' || recommendedDailyDiet <= 0 || isNaN(recommendedDailyDiet)) {
            console.error('Invalid recommendedDailyDiet value. It must be a positive number.');

            return null;
        }

        let lowestPercentage = Infinity;
        let bestOption = null;

        for (let i = 0; i < portionOptions.length; i++) {
            const { portionCount } = portionOptions[i];

            for (let j = 0; j < portionWeights.length; j++) {
                const portionWeight = portionWeights[j];
                const totalAmount = portionCount * portionWeight;

                if (totalAmount >= recommendedDailyDiet) {
                    const percentage = ((totalAmount - recommendedDailyDiet) / recommendedDailyDiet) * 100;

                    if (percentage < lowestPercentage) {
                        lowestPercentage = percentage;
                        bestOption = {
                            portionCount,
                            portionWeight,
                            percentage: parseFloat(percentage.toFixed(2)),
                            rounded: 'UP',
                            exceedsThreshold: false,
                        };
                    }
                    break;
                }
            }
        }

        return bestOption ? bestOption : null;
    }

    const idealPortionDown = getRoundedDownPortion(recommendedDailyDiet, portionWeights, dogWeightKg);

    function getRoundedDownPortion(recommendedDailyDiet, portionWeights, dogWeightKg) {
        const portionOptions =
            dogWeightKg > 4.4
                ? [{ portionCount: 1 }, { portionCount: 2 }]
                : [{ portionCount: 0.5 }, { portionCount: 1 }, { portionCount: 2 }];

        if (typeof recommendedDailyDiet !== 'number' || recommendedDailyDiet <= 0 || isNaN(recommendedDailyDiet)) {
            console.error('Invalid recommendedDailyDiet value. It must be a positive number.');
            return null;
        }

        let lowestPercentage = -Infinity;
        let bestOption = null;

        if (typeof recommendedDailyDiet !== 'number' || recommendedDailyDiet <= 0) {
            console.error('Invalid recommendedDailyDiet value. It must be a positive number.');
            return null;
        }

        for (let i = 0; i < portionOptions.length; i++) {
            const { portionCount } = portionOptions[i];

            for (let j = 0; j < portionWeights.length; j++) {
                const portionWeight = portionWeights[j];
                const totalAmount = portionCount * portionWeight;

                if (totalAmount <= recommendedDailyDiet) {
                    const percentage = ((totalAmount - recommendedDailyDiet) / recommendedDailyDiet) * 100;

                    if (percentage > lowestPercentage) {
                        lowestPercentage = percentage;
                        bestOption = {
                            portionCount,
                            portionWeight,
                            percentage: parseFloat(percentage.toFixed(2)),
                            rounded: 'DOWN',
                            exceedsThreshold: false,
                        };
                    }
                }
            }
        }

        return bestOption ? bestOption : null;
    }

    let idealPortion = selectIdealPortion(
        idealPortionUp,
        idealPortionDown,
        neutered,
        activityLevel,
        bodyCondition,
        mealPlanType
    );
    function selectIdealPortion(
        idealPortionUp,
        idealPortionDown,
        neutered,
        activityLevel,
        bodyCondition,
        mealPlanType
    ) {
        const portionMap = {
            'yes-low-below': 'UP',
            'yes-low-adequate': 'DOWN',
            'yes-low-above': 'DOWN',
            'yes-high-below': 'UP',
            'yes-high-adequate': 'UP',
            'yes-high-above': 'DOWN',
            'yes-moderate-below': 'UP',
            'yes-moderate-adequate': 'DOWN',
            'yes-moderate-above': 'DOWN',
            'no-low-below': 'UP',
            'no-low-adequate': 'UP',
            'no-low-above': 'DOWN',
            'no-high-below': 'UP',
            'no-high-adequate': 'UP',
            'no-high-above': 'DOWN',
            'no-moderate-below': 'UP',
            'no-moderate-adequate': 'UP',
            'no-moderate-above': 'DOWN',
        };

        const cutoffPercentageUp = 15;
        const cutoffPercentageDown = -10;

        const suggestion = portionMap[`${neutered}-${activityLevel}-${bodyCondition}`];
        const isValidPortion = (portion) => portion && typeof portion.percentage === 'number';
        const hasValidUp = isValidPortion(idealPortionUp);
        const hasValidDown = isValidPortion(idealPortionDown);

        if (!hasValidUp && !hasValidDown) return null;

        let selectedPortion = null;
        let calculateClosestToZero = false;

        if (suggestion === 'UP') {
            if (hasValidUp && idealPortionUp.percentage <= cutoffPercentageUp) {
                selectedPortion = JSON.parse(JSON.stringify(idealPortionUp));
            } else if (hasValidDown && idealPortionDown.percentage >= cutoffPercentageDown) {
                selectedPortion = { ...JSON.parse(JSON.stringify(idealPortionDown)), exceedsThreshold: true };
            } else {
                calculateClosestToZero = true;
                selectedPortion = null;
            }
        } else if (suggestion === 'DOWN') {
            if (hasValidDown && idealPortionDown.percentage >= cutoffPercentageDown) {
                selectedPortion = JSON.parse(JSON.stringify(idealPortionDown));
            } else if (hasValidUp && idealPortionUp.percentage <= cutoffPercentageUp) {
                selectedPortion = { ...JSON.parse(JSON.stringify(idealPortionUp)), exceedsThreshold: true };
            } else {
                calculateClosestToZero = true;
                selectedPortion = null;
            }
        }

        if (calculateClosestToZero) {
            selectedPortion =
                hasValidUp && hasValidDown
                    ? Math.abs(idealPortionUp.percentage) < Math.abs(idealPortionDown.percentage)
                        ? { ...idealPortionUp, exceedsThreshold: true }
                        : { ...idealPortionDown, exceedsThreshold: true }
                    : hasValidUp
                        ? { ...idealPortionUp, exceedsThreshold: true }
                        : hasValidDown
                            ? { ...idealPortionDown, exceedsThreshold: true }
                            : null;
        }

        if (selectedPortion) {
            if (mealPlanType === 'full') {
                selectedPortion.sellingPlanID = fullSellingPlan.id;
                selectedPortion.sellingPlanFrequency = fullSellingPlan.frequency;

                selectedPortion.recommendation =
                    selectedPortion.portionCount === 0.5
                        ? 'Half per day'
                        : selectedPortion.portionCount === 1
                            ? 'One per day'
                            : selectedPortion.portionCount === 2
                                ? 'Two per day'
                                : (console.error("Invalid inputs for 'Full Meal Plan': portionCount must be '0.5', '1', or '2'."), null);
            } else if (mealPlanType === 'topper') {
                selectedPortion.sellingPlanID = topperSellingPlan.id;
                selectedPortion.sellingPlanFrequency = topperSellingPlan.frequency;

                selectedPortion.recommendation =
                    selectedPortion.portionCount === 0.5
                        ? '1/4 (A quarter per day)'
                        : selectedPortion.portionCount === 1
                            ? 'Half per day'
                            : selectedPortion.portionCount === 2
                                ? 'One per day'
                                : (console.error("Invalid inputs for 'Full Meal Plan': portionCount must be '0.5', '1', or '2'."), null);
            } else {
                console.error("Invalid mealPlanType: must be 'Topper Meal Plan' or 'full'.");
                return null;
            }
        }

        selectedPortion.mealPlanType = mealPlanType;

        return selectedPortion;
    }

    const portionsPerDelivery = getPortionsPerDelivery(idealPortion, mealsPerDelivery);
    function getPortionsPerDelivery(idealPortion, mealsPerDelivery) {
        if (!idealPortion || typeof idealPortion.portionCount !== 'number') {
            console.error('Invalid idealPortion: it must contain a numeric portionCount.');
            return null;
        }

        const portionCount = idealPortion.portionCount;
        const isValidPortionCount = portionCount > 0;

        let portionsPerDelivery = null;

        if (isValidPortionCount) {
            portionsPerDelivery = portionCount * mealsPerDelivery;
        } else {
            console.error('Invalid inputs: portionCount must be a positive number');
        }

        return portionsPerDelivery;
    }

    const mealDistribution = distributeMeals(portionsPerDelivery, proteinPreference);
    function distributeMeals(portionsPerDelivery, proteinPreference) {
        const isValidPortions = typeof portionsPerDelivery === 'number' && portionsPerDelivery >= 0;
        const isValidproteinPreference = Array.isArray(proteinPreference) && proteinPreference.length > 0;

        let mealDistribution = {};

        if (isValidPortions && isValidproteinPreference) {
            const numFlavors = proteinPreference.length;
            const basePortion = Math.floor(portionsPerDelivery / numFlavors);
            const remainder = portionsPerDelivery % numFlavors;

            proteinPreference.forEach((flavor) => {
                mealDistribution[flavor] = basePortion;
            });

            for (let i = 0; i < remainder; i++) {
                const flavor = proteinPreference[i];
                mealDistribution[flavor] += 1;
            }
        } else {
            console.error(
                'Invalid input: portionsPerDelivery should be a non-negative number and proteinPreference should be a non-empty array.'
            );

            if (Array.isArray(proteinPreference)) {
                proteinPreference.forEach((flavor) => {
                    mealDistribution[flavor] = 0;
                });
            }
        }
        return mealDistribution;
    }

    const calIntakeElement = document.getElementById('cal-intake');
    calIntakeElement.textContent = Math.round(maintenanceEnergyRequirement);

    const bodyConditionTexts = {
        below: 'lean and lively',
        adequate: 'fit and healthy',
        above: 'full of love',
    };

    const ageDescriptorText = (age) => {
        if (age.year < 2) {
            return 'young pup';
        } else if (age.year > 8) {
            return 'wise companion';
        } else {
            return 'energetic adult';
        }
    };

    const activityLevelTexts = {
        low: 'laid-back lounger',
        moderate: 'playful explorer',
        high: 'always on the go',
    };

    const mealPreferenceTexts = {
        yes: 'Starting their fresh food journey, Joey’s Raw makes the switch easy with meals that support digestion and',
        no: 'Already a fresh food enthusiast, Joey’s Raw provides meals tailored to',
    };

    const goalTexts = {
        improved_digestion: 'improved digestion',
        healthier_skin: 'healthier skin',
        weight_management: 'weight management',
        increased_energy: 'increased energy',
        stronger_immune_system: 'stronger immune system',
        quality_of_life: 'quality of life',
    };

    document.querySelector('.body-condition').textContent = bodyConditionTexts[bodyCondition];
    document.querySelector('.activity-level').textContent = activityLevelTexts[activityLevel];
    document.querySelector('.age-descriptor').textContent = ageDescriptorText(age);
    document.querySelector('.transitioning-status').textContent = mealPreferenceTexts[transition];
    console.log('goals...........', goals);
    if (Array.isArray(goals)) {
    var goalsText = goals.map((goal) => goalTexts[goal] || goal).join(', ');
    } else {
    console.warn('goals não é um array:', goals);
    }
    document.querySelector('.selected-goal').textContent = goalsText;
    const infoP3Element = document.querySelector('.info-p .p3');
    const recommendationText = idealPortion.recommendation;
    const infoP4Element = document.querySelector('.info-p .p4');

    if (infoP4Element) {
        infoP4Element.textContent = recommendationText;
    } else {
        console.error('Elemento com a classe .info-p .p4 não encontrado.');
    }

    if (infoP3Element) {
        infoP3Element.textContent = `${portionsPerDelivery} packs`;
    } else {
        console.error('Elemento com a classe .info-p .p3 não encontrado.');
    }

    const targetElement = document.querySelector('.info-topper-full-box');
    const infoPElement = document.querySelector('.info-p .p1');
    const frequencyPlanElement = document.querySelector('.frequencyPlan');
    const stepButtonServing = document.querySelector('.step-3q1-button');
    const stepButtonToTopperFull = document.getElementById('step-3-q2');

    if (targetElement && infoPElement && frequencyPlanElement) {
        function updateTextsBasedOnClass() {
            if (targetElement.classList.contains('full-selected')) {
                infoPElement.textContent = 'Full: 100% of daily nutritional needs';
                frequencyPlanElement.textContent = 'every 2 weeks';
            } else if (targetElement.classList.contains('topper-selected')) {
                infoPElement.textContent = 'Topper: 50% of daily nutritional needs';
                frequencyPlanElement.textContent = 'every month';
            }
        }

        const observer = new MutationObserver(() => {
            updateTextsBasedOnClass();
        });

        observer.observe(targetElement, { attributes: true, attributeFilter: ['class'] });
        updateTextsBasedOnClass();
    }

    if (targetElement && infoP4Element) {
        let servingFull = '';
        let servingTopper = '';

        function initializeServingValues() {
            const currentRecommendation = recommendationText;

            if (targetElement.classList.contains('full-selected')) {
                if (currentRecommendation === 'Two per day') {
                    servingTopper = 'One per day';
                } else if (currentRecommendation === 'One per day') {
                    servingTopper = 'Half per day';
                } else if (currentRecommendation === 'Half per day') {
                    servingTopper = '1/4 (A quarter per day)';
                }
                servingFull = currentRecommendation;
            } else if (targetElement.classList.contains('topper-selected')) {
                if (currentRecommendation === '1/4 (A quarter per day)') {
                    servingFull = 'Half per day';
                } else if (currentRecommendation === 'Half per day') {
                    servingFull = 'One per day';
                } else if (currentRecommendation === 'One per day') {
                    servingFull = 'Two per day';
                }
                servingTopper = currentRecommendation;
            }

            stepButtonToTopperFull.addEventListener('click', () => {
                if (targetElement.classList.contains('full-selected')) {
                    infoP4Element.textContent = servingFull;
                } else if (targetElement.classList.contains('topper-selected')) {
                    infoP4Element.textContent = servingTopper;
                }
            });
        }
        initializeServingValues();
    }

    const listMeals = document.querySelector('.list-meals');
    function populateMealList() {
        listMeals.innerHTML = '';

        for (const [mealType, count] of Object.entries(mealDistribution)) {
            const prefix = 'Gently Steamed';

            const listItem = document.createElement('li');
            listItem.textContent = `${prefix} ${capitalizeFirstLetter(mealType)} (${mealDistribution[mealType]} packs)`;

            listMeals.appendChild(listItem);
        }
    }

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    populateMealList();

    const variantsFetch = fetchProductVariants(mealDistribution, mealPreference, idealPortion);
    async function addProductsToCart(variantsData) {
        const cartUrl = window.Shopify.routes.root + 'cart/add.js';

        try {
            const localstore = JSON.parse(localStorage.getItem('quizAnswers') || {});

            await fetch(cartUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: variantsData.map((v) => {
                        let sellingPlan = fullSellingPlan.id;

                        if (localstore[0].mealPlanType == 'topper') {
                            sellingPlan = topperSellingPlan.id;
                        }
                        return {
                            id: v.variantId,
                            quantity: v.quantity,
                            selling_plan: sellingPlan,
                            properties: {
                                'Dog Name': localstore[0].name,
                            },
                        };
                    }),
                }),
            });
        } catch (error) {
            console.log(error);
        }
    }

    async function fetchProductVariants(mealDistribution, mealPreference, idealPortion) {
        const baseUrl = '/collections/all/protein-type-';
        const viewType = '?view=ajax';
        const variantsData = [];
        let totalVariantPrice = 0;

        for (const [proteinType, quantity] of Object.entries(mealDistribution)) {
            const fetchUrl = `${baseUrl}${proteinType}+meal-preference-${mealPreference}${viewType}`;

            try {
                const response = await fetch(fetchUrl);

                if (!response.ok) {
                    console.warn(`Erro na resposta para ${proteinType}. Status: ${response.status}`);
                    continue;
                }

                let productData;
                try {
                    productData = JSON.parse(await response.text());
                } catch (err) {
                    console.warn(`Erro ao parsear JSON para ${proteinType}.`, err);
                    continue;
                }

                if (!Array.isArray(productData) || productData.length === 0 || !productData[0]?.variants) {
                    continue;
                }

                const selectedVariant = productData[0].variants.find((variant) => {
                    const variantFromList = variantsList.find((item) => item.title == variant.title);
                    const variantWeight = variantFromList ? variantFromList.weight : null;
                    return variantWeight && variantWeight === idealPortion.portionWeight;
                });

                if (!selectedVariant) {
                    console.warn(`Nenhuma variante correspondente encontrada para ${proteinType}.`);
                    continue;
                }

                totalVariantPrice += selectedVariant.price * quantity;

                variantsData.push({
                    variantId: selectedVariant.id,
                    quantity,
                    sellingPlanID: idealPortion.sellingPlanID,
                });
            } catch (error) {
                console.error(`Erro ao processar ${proteinType}:`, error);
            }
        }

        return { variantsData, totalVariantPrice };
    }

    return {
        addProductsToCart: addProductsToCart,
        fetchProductVariants: fetchProductVariants,
        mealDistribution: mealDistribution,
        mealPreference: mealPreference,
        idealPortion: idealPortion,
        energyFactor: energyFactor,
        recommendedDailyDiet: recommendedDailyDiet,
        portionsPerDelivery: portionsPerDelivery,
        idealPortionUp: idealPortionUp,
        idealPortionDown: idealPortionDown,
    };
}

const startJSfields = document.getElementById('step-3q1');
const secureCheckoutButton = document.querySelector('.cart-quiz-checkout');
const addAnotherDogButton = document.getElementById('add-another-dog');
const checkButtonMeal = document.querySelectorAll('.protein-checkbox');
var variantsData2 = {};

document.addEventListener('DOMContentLoaded', function () {
    let totalVariantPrice;
    setTimeout(() => {
        startJSfields.click();
    }, 1000);
    
    if (startJSfields) {
        checkButtonMeal.forEach((button) => {
            button.addEventListener('change', function () {
                changePrice()
            }); 
        });
        startJSfields.addEventListener('click', function() {
            changePrice();
            const targetElement = document.querySelector('#step-3-q2');
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        });

        async function changePrice() {
            window.exeFunc = executeCodeFirst();
            const { variantsData, totalVariantPrice: fetchedPrice } = await window.exeFunc.fetchProductVariants(
                window.exeFunc.mealDistribution,
                window.exeFunc.mealPreference,
                window.exeFunc.idealPortion
            );
            secureCheckoutButton.disabled = false;
            variantsData2 = variantsData;
            totalVariantPrice = fetchedPrice;
            updatePrice();
        }
        
    } else {
        console.warn('Elemento startJSfields não encontrado.');
    }

    function updatePrice() {
        const targetElement = document.querySelector('.info-topper-full-box');
        const totalPriceSpan = document.querySelector('.total-price-week');
        const totalPriceSpanOld = document.querySelector('.total-price-week-old');
        const fullPriceSpan = document.querySelector('.full.new-price');
        const topperPriceSpan = document.querySelector('.topper.new-price');
        const fullPriceSpanOld = document.querySelector('.full.old-price');
        const topperPriceSpanOld = document.querySelector('.topper.old-price');
        const p2Element = document.querySelector('.p2');
        const valueDayPlanSpan = document.querySelector('.value-day-plan');

        if (totalVariantPrice === undefined) {
            console.warn('totalVariantPrice ainda não está disponível.');
            return;
        }

        let updatedPrice;

        if (targetElement && totalPriceSpan && totalPriceSpanOld) {
            if (targetElement.classList.contains('full-selected')) {
                updatedPrice = totalVariantPrice / 2;
                if (p2Element) {
                    p2Element.textContent = fullSellingPlan.amountDescription;
                }
                if (valueDayPlanSpan) {
                    const fullPrice = (totalVariantPrice / 2 / fullSellingPlan.daysOfFood / 100).toFixed(2);
                    valueDayPlanSpan.textContent = `$${fullPrice}`;
                }
            } else if (targetElement.classList.contains('topper-selected')) {
                updatedPrice = totalVariantPrice / 4;
                if (p2Element) {
                    p2Element.textContent = topperSellingPlan.amountDescription;
                }
                if (valueDayPlanSpan) {
                    const topperPrice = (totalVariantPrice / 2 / topperSellingPlan.daysOfFood / 100).toFixed(2);
                    valueDayPlanSpan.textContent = `$${topperPrice}`;
                }
            } else {
                updatedPrice = totalVariantPrice;
            }

            totalPriceSpan.textContent = (totalVariantPrice / 100).toFixed(2);
            totalPriceSpanOld.textContent = (totalVariantPrice / 2 / 100).toFixed(2);
        }

        if (fullPriceSpan) {
            const fullPrice = (totalVariantPrice / fullSellingPlan.daysOfFood / 100).toFixed(2);
            fullPriceSpan.textContent = `$${fullPrice}`;
        }

        if (topperPriceSpan) {
            const topperPrice = (totalVariantPrice / topperSellingPlan.daysOfFood / 100).toFixed(2);
            topperPriceSpan.textContent = `$${topperPrice}`;
        }
        if (fullPriceSpanOld) {
            const fullPriceOld = (totalVariantPrice / 2 / fullSellingPlan.daysOfFood / 100).toFixed(2);
            fullPriceSpanOld.textContent = `$${fullPriceOld}`;
        }

        if (topperPriceSpanOld) {
            console.log('topperSellingPlan.daysOfFood', totalVariantPrice, topperSellingPlan.daysOfFood);
            const topperPriceOld = (totalVariantPrice / 2 / topperSellingPlan.daysOfFood / 100).toFixed(2);
            topperPriceSpanOld.textContent = `$${topperPriceOld}`;
        }
    }

    const targetElement = document.querySelector('.info-topper-full-box');
    if (targetElement) {
        const observer = new MutationObserver(() => {
            updatePrice();
        });

        observer.observe(targetElement, { attributes: true, attributeFilter: ['class'] });
    } else {
        console.warn('Elemento .info-topper-full-box não encontrado.');
    }
});

function openModal(modal) {
    modal.style.display = 'block';
}

function closeModal(modal) {
    modal.style.display = 'none';
}

const secureCheckoutModal = document.querySelector('.modal-secure-checkout');
const secureCheckoutCancel = document.querySelector('.modal-secure-checkout .cancel-btn');

if (secureCheckoutButton) {
    secureCheckoutButton.addEventListener('click', async function () {
        secureCheckoutButton.disabled = true;
        secureCheckoutButton.innerHTML = 'Adding to cart <span class="loading-circle"></span>';

        if (typeof window.exeFunc.addProductsToCart === 'function') {
            await window.exeFunc.addProductsToCart(variantsData2);

            try {
                const persistentStorage = JSON.parse(localStorage.getItem('quizAnswers') || '[]');
                const tempStorage = JSON.parse(sessionStorage.getItem('quizDogs') || '[]');

                if (persistentStorage.length > 0) {
                    tempStorage.push(persistentStorage[0]);
                    sessionStorage.setItem('quizDogs', JSON.stringify(tempStorage));
                }

                const attributes = {};
                tempStorage.forEach((quizAnswer, index) => {
                    attributes[`quizAnswer_${index + 1}`] = JSON.stringify(quizAnswer);
                });

                attributes['function_energyFactor'] = window.exeFunc.energyFactor;
                attributes['function_recommendedDailyDiet'] = window.exeFunc.recommendedDailyDiet;
                attributes['function_portionsPerDelivery'] = window.exeFunc.portionsPerDelivery;
                attributes['function_mealDistribution'] = JSON.stringify(window.exeFunc.mealDistribution);
                attributes['function_idealPortionUp'] = JSON.stringify(window.exeFunc.idealPortionUp);
                attributes['function_idealPortionDown'] = JSON.stringify(window.exeFunc.idealPortionDown);
                attributes['function_idealPortion'] = JSON.stringify(window.exeFunc.idealPortion);

                const deliveryDate = getNextDeliveryDate();
                const yyyy = deliveryDate.getFullYear();
                const mm = String(deliveryDate.getMonth() + 1).padStart(2, '0');
                const dd = String(deliveryDate.getDate()).padStart(2, '0');
                attributes['_delivery_date'] = `${yyyy}-${mm}-${dd}`;

                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ attributes })
                });
            } catch (err) {
                console.error(err);
            }

            setTimeout(function () {
                window.localStorage.clear();
                window.location.href = '/checkout?discount=JOEYS50';
            }, 1000);
        } else {
            console.error('addProductsToCart is not defined!');
            secureCheckoutButton.disabled = false;
            secureCheckoutButton.innerHTML = 'Checkout';
        }
    });
}

const addAnotherDogModal = document.querySelector('.modal-add-another-dog');
const addAnotherDogConfirm = document.querySelector('.modal-add-another-dog .confirm-btn');
const addAnotherDogCancel = document.querySelector('.modal-add-another-dog .cancel-btn');

if (addAnotherDogButton) {
    addAnotherDogButton.addEventListener('click', function () {
        openModal(addAnotherDogModal);
    });

    addAnotherDogConfirm.addEventListener('click', async function () {
        if (typeof window.exeFunc.addProductsToCart === 'function') {
            await window.exeFunc.addProductsToCart(variantsData2);

            try {
                const persistentStorage = JSON.parse(localStorage.getItem('quizAnswers') || '[]');
                const tempStorage = JSON.parse(sessionStorage.getItem('quizDogs') || '[]');

                if (persistentStorage.length > 0) {
                    tempStorage.push(persistentStorage[0]);
                    sessionStorage.setItem('quizDogs', JSON.stringify(tempStorage));
                }

                const attributes = {};
                tempStorage.forEach((quizAnswer, index) => {
                    attributes[`quizAnswer_${index + 1}`] = JSON.stringify(quizAnswer);
                });

                attributes['function_energyFactor'] = window.exeFunc.energyFactor;
                attributes['function_recommendedDailyDiet'] = window.exeFunc.recommendedDailyDiet;
                attributes['function_portionsPerDelivery'] = window.exeFunc.portionsPerDelivery;
                attributes['function_mealDistribution'] = JSON.stringify(window.exeFunc.mealDistribution);
                attributes['function_idealPortionUp'] = JSON.stringify(window.exeFunc.idealPortionUp);
                attributes['function_idealPortionDown'] = JSON.stringify(window.exeFunc.idealPortionDown);
                attributes['function_idealPortion'] = JSON.stringify(window.exeFunc.idealPortion);

                const deliveryDate = getNextDeliveryDate();
                const yyyy = deliveryDate.getFullYear();
                const mm = String(deliveryDate.getMonth() + 1).padStart(2, '0');
                const dd = String(deliveryDate.getDate()).padStart(2, '0');
                attributes['_delivery_date'] = `${yyyy}-${mm}-${dd}`;

                console.log('>>>', attributes);

                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ attributes })
                });
            } catch (err) {
                console.error(err);
            }

            setTimeout(function () {
                window.localStorage.clear();
                location.reload();
            }, 2000);
        } else {
            console.error('addProductsToCart is not defined!');
        }
        closeModal(addAnotherDogModal);
    });

    addAnotherDogCancel.addEventListener('click', function () {
        closeModal(addAnotherDogModal);
    });
}

const startJSProd = document.getElementById('build-plan-button');
if (startJSProd) {
    startJSProd.addEventListener('click', function () {
        window.exeFunc = executeCodeFirst();
        updateDeliveryDate();
    });
}

/**
 * Delivery date cut-off rules (Eastern Time):
 * - Orders Mon 10:01am → Fri 10:00am  ⇒  next Sunday
 * - Orders Fri 10:01am → Mon 10:00am  ⇒  next Wednesday
 */
function getNextDeliveryDate() {
    const now = new Date();
    const etString = now.toLocaleString('en-US', { timeZone: 'America/Toronto' });
    const et = new Date(etString);

    const day = et.getDay(); // 0=Sun,1=Mon,...,6=Sat
    const hour = et.getHours();
    const minute = et.getMinutes();
    const totalMinutes = hour * 60 + minute; // minutes since midnight
    const cutoff = 10 * 60; // 10:00am = 600 minutes

    // Determine which window we're in
    // "weekday window": Mon 10:01 → Fri 10:00  ⇒ delivery Sunday
    // "weekend window": Fri 10:01 → Mon 10:00  ⇒ delivery Wednesday
    let isWeekdayWindow;

    if (day >= 1 && day <= 4) {
        // Mon–Thu
        if (day === 1 && totalMinutes <= cutoff) {
            // Monday up to 10:00am is still weekend window
            isWeekdayWindow = false;
        } else {
            isWeekdayWindow = true;
        }
    } else if (day === 5) {
        // Friday
        isWeekdayWindow = totalMinutes <= cutoff;
    } else {
        // Sat (6) or Sun (0)
        isWeekdayWindow = false;
    }

    const delivery = new Date(et);
    delivery.setHours(0, 0, 0, 0);

    if (isWeekdayWindow) {
        // Next Sunday (day 0)
        const daysUntilSunday = (7 - day) % 7;
        delivery.setDate(delivery.getDate() + (daysUntilSunday === 0 ? 7 : daysUntilSunday));
    } else {
        // Next Wednesday (day 3)
        let daysUntilWed = (3 - day + 7) % 7;
        if (daysUntilWed === 0) daysUntilWed = 7;
        delivery.setDate(delivery.getDate() + daysUntilWed);
    }

    return delivery;
}

function updateDeliveryDate() {
    const el = document.getElementById('delivery-date');
    if (!el) return;

    const delivery = getNextDeliveryDate();
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    el.textContent = delivery.toLocaleDateString('en-US', options);
}

// Update on page load as well
document.addEventListener('DOMContentLoaded', function () {
    updateDeliveryDate();
});


